<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<h1 class="title">ARTHUR, PRINCE OF WALES</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?79974e62